<template>
    <v-container fluid grid-list-xl white>
      <iframe title="AZCronos"
              :src="getCronosCategoriaEscolhidaUrl"
              id="iframAZCronos"
              class="iframe-az-cronos pa-3"></iframe>
    </v-container>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'AZCronosInformacao',
    data: () => {
        return {
            cronosCategorias: {
                novidades: {
                    url: '/categoria/compra-direta/'
                },
                sugestoes: {
                    url: '/sugestoes?categoria=4'
                },
                roadmaps: {
                    url: '/roadmaps?categoria=4'
                },
            }
        }
    },
    computed: {
        ...mapState(['parametros']),
        getCronosCategoriaEscolhidaUrl() {
            return this.getCronosBaseUrl + this.cronosCategorias[this.$route.meta.cronosCategoria].url
        },
        getCronosBaseUrl(){
            return this.parametros.propriedadesCompraDiretas.integration.cronos.url
        }
    },
}
</script>

<style scoped lang="stylus">
    .iframe-az-cronos
        width 100% !important
        height calc(100vh - 96px) !important
        border none
</style>